import React, { useState, useEffect } from 'react';
import { Auth, API } from 'aws-amplify';
import './AccessControlTab.css';

const roles = ['Admin', 'Editor', 'Reconciler', 'Viewer', 'No Access'];

const AccessControlTab = ({ configData, title, users, userRole, userEmail, onRoleChange }) => {
  const [userRoles, setUserRoles] = useState({});
  const [isSaving, setIsSaving] = useState(false); // State to track saving status

  useEffect(() => {
    if (users) {
      setUserRoles(users);
    }
  }, [users]);

  // Handle dropdown role selection (updates local state only)
  const handleRoleChange = (userKey, newRole) => {
    if (userRole.toLowerCase() !== 'admin') return; // Only allow Admins to make changes

    setUserRoles((prevRoles) => ({
      ...prevRoles,
      [userKey]: { ...prevRoles[userKey], role: newRole },
    }));
  };

  // Save changes to the API
  const saveUserRoles = async () => {
    setIsSaving(true);
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      const title = configData.title;
      const userOrganization = currentUser.attributes['email'].split('@')[1].split('.')[0];
      const apiName = 'EditMap'; // Change this to your actual API name
      const path = '/editmap';   // Change this to your actual API endpoint

      const bodyData = {
        title: title,
        organization: userOrganization,
        users: userRoles, // Updated user roles object
        currentEmail: userEmail, // The email of the logged-in user making the change
        currentRole: userRole // The role of the logged-in user making the change
      };

      const response = await API.post(apiName, path, { body: bodyData });

      if (response.success) {
        alert('User roles updated successfully');
      } else {
        alert('Error updating user roles, please try again.');
      }
    } catch (error) {
      alert('Error updating user roles, please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="access-control-tab">
      <h2>Access Control</h2>

      {/* Users Table */}
      {Object.keys(userRoles).length > 0 ? (
        <table className="access-control-table">
   <thead>
  <tr>
    <th>#</th>
    <th>Email</th>
    <th className="role-header">
      Role
      {userRole.toLowerCase() === 'admin' && (
        <button className="save-button" onClick={saveUserRoles} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Changes'}
        </button>
      )}
    </th>
  </tr>
</thead>



          
          <tbody>
            {Object.entries(userRoles).map(([key, user], index) => (
              <tr key={key}>
                <td>{index + 1}</td>
                <td className="email-cell">
                  {user.email}
                  {user.email === userEmail && <span className="green-circle"></span>}
                </td>
                <td>
                  <select
                    className="role-dropdown"
                    value={user.role}
                    onChange={(e) => handleRoleChange(key, e.target.value)}
                    disabled={userRole.toLowerCase() !== 'admin'} // Only Admins can edit
                  >
                    {roles.map((role) => (
                      <option key={role} value={role}>
                        {role}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
          
        </table>
      ) : (
        <p>No users available.</p>
      )}



      {/* Role Descriptions Table */}
      <div className="role-descriptions">
        <h3>Role Permissions</h3>
        <table className="role-table">
          <thead>
            <tr>
              <th>Permission</th>
              <th>No Access</th>
              <th>Viewer</th>
              <th>Reconciler</th>
              <th>Editor</th>
              <th>Admin</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>View Recon</td><td>❌</td><td>✔️</td><td>✔️</td><td>✔️</td><td>✔️</td></tr>
            <tr><td>View Audit Trail</td><td>❌</td><td></td><td>✔️</td><td>✔️</td><td>✔️</td></tr>
            <tr><td>Modify Break Status</td><td>❌</td><td></td><td>✔️</td><td>✔️</td><td>✔️</td></tr>
            <tr><td>Run Reconciliation</td><td>❌</td><td></td><td>✔️</td><td>✔️</td><td>✔️</td></tr>
            <tr><td>Upload Files</td><td>❌</td><td></td><td>✔️</td><td>✔️</td><td>✔️</td></tr>
            <tr><td>Edit Configuration</td><td>❌</td><td></td><td></td><td>✔️</td><td>✔️</td></tr>
            <tr><td>Delete Recon</td><td>❌</td><td></td><td></td><td></td><td>✔️</td></tr>
            <tr><td>Edit User Permissions</td><td>❌</td><td></td><td></td><td></td><td>✔️</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccessControlTab;
